<template>
    <v-form v-model="valid" ref="form">
        <v-container fluid>
            <div class="headline">{{__('labels.royalty')}}</div>
            <div class="subheading">{{__('labels.royalty_subtitle')}}</div>
            <v-layout row wrap>
                <v-flex xs12>
                    <s-price-field
                            v-model="royalties"
                            :label="__('labels.royalty_royalty')"
                            :rules="rules.royalties">
                    </s-price-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex shrink>
                    <button-previous></button-previous>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                    <button-next @click="nextButtonClick()"></button-next>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    import {mapMutations} from 'vuex'
    import {mapActions} from 'vuex'
    export default {
        name: "RoyaltyStep",
        computed: {
            royalties: {
                get() {
                    return this.$store.state.form.royalties;
                },
                set(v) {
                    this.$store.commit('form/setRoyalties', v);
                }
            },
        },
        data() {
            return {
                valid: false,
                rules: this.$validation.create({
                        royalties: [],
                    }
                )
            }
        },
        methods: {
            ...mapMutations('stepper', [
                'nextStep'
            ]),
            ...mapActions('form', [
                'setError',
            ]),
            nextButtonClick() {
                if (this.$refs.form.validate()) {
                    this.$cookies.set('royalties', this.royalties);
                    this.nextStep();
                } else {
                    this.setError(this.__('messages.form_invalid'));
                }
            },
        },
    }
</script>

<style scoped>

</style>